import React from 'react'

export default function Path({ strokeColor, strokeWidth, strokeOpacity, d }) {
  return (
    <path
      className="Path"
      fill="none"
      stroke={strokeColor || 'red'}
      d={d}
      strokeWidth={strokeWidth || '1px'}
      strokeOpacity={strokeOpacity || 1}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  )
}
